import { PathMenuItem } from "core/FeaturePathMenus";

export const pathMenus: PathMenuItem[] = [
  {
    url_id: "/laporan/portfolio-bsya-junior",
    url_path: "/laporan/portfolio-bsya-junior",
  },
];
